export { LogoCloudSection as LogoMarquee } from "../credibility-sections"
export type { LogoCloudSectionProps as LogoMarqueeProps } from "../credibility-sections"